/**
 * A dash that is used for ranges of value (e.g. "Mon-Fri")
 * See: https://en.wikipedia.org/wiki/Dash#Em_dash
 */
export const EmDash = '—';

/**
 * A dash that is used for ranges of value (e.g. "Mon-Fri")
 * See: https://en.wikipedia.org/wiki/Dash#En_dash
 */
export const EnDash = '–';

/**
 * A space that prevents word-break
 * See: https://en.wikipedia.org/wiki/Non-breaking_space
 */
export const NonBreakingSpace = ' ';
